import React from 'react';
import { FIELD_HELP } from '@vanilla/constants/FieldHelp.js';

const INFO_SVG = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><circle cx="7" cy="7" r="6" stroke="currentColor" stroke-width="1"/><path d="M7 6.2V10M7 4.2h.01" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>`;
// SAFE: INFO_SVG is a hardcoded static string (no user input), never interpolated.
// dangerouslySetInnerHTML is safe here; eslint react/no-danger is suppressed by allowlist.

export function FieldHelpIcon({ fieldId }) {
  const help = FIELD_HELP[fieldId];
  if (!help) return null;
  return (
    <button
      type="button"
      className="field-help-icon"
      aria-label={`Help: ${help.title}`}
      data-help-title={help.title}
      data-help-body={help.body}
      dangerouslySetInnerHTML={{ __html: INFO_SVG }} // eslint-disable-line react/no-danger -- INFO_SVG is hardcoded static (no interpolation)
    />
  );
}

export default FieldHelpIcon;
